var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"toast-fade"}},[(_vm.show)?_c('div',{staticClass:"toast"},[_c('div',{staticClass:"toast-backdrop"}),_vm._v(" "),_c('div',{staticClass:"toast-dialog",class:[_vm.positionClass]},[_c('div',{staticClass:"toast-content",class:[_vm.typeClass]},[_c('div',[_vm._v(_vm._s(_vm.msg))])])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-512bf43e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/toast/toast.vue
// module id = null
// module chunks = 